<script>
    /*
    	FieldGroupExpandBar.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components
    import ToggleStateButton from '../buttons/ToggleStateButton.svelte';

    // SMUI components

    const SVG_EXPANDED_PATH  = '/svg-icons/nav-icons/field-group-open.svg';
    const SVG_COLLAPSED_PATH = '/svg-icons/nav-icons/field-group-closed.svg';

    export let title;
    export let isExpanded;
    export let toggleIsExpanded;

    onMount(() => {
    })

</script>

<style>

    :global(.field-group-expand-bar .toggle-state-button) {
        width: 22px !important;
        height: 22px !important;
    }

    .expand-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .expand-row .title {
        margin-left: 15px;
        font-size: 14px;
        text-transform: uppercase;
    }

    :global(.expand-row svg) {
        fill: var(--tcare-dull-purple);
    }



    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!--
{#if showDiffs}
    {#if getDiffCount() > 0}<span class="diff-count">({getDiffCount()})</span>{/if}
{/if}
-->

<div class="field-group-expand-bar">
    <div class="expand-row">
        <!-- <ExpandCollapseButton isExpanded={isExpanded} {toggleIsExpanded}/> -->
        <ToggleStateButton 
            state={isExpanded} 
            toggleFunction={toggleIsExpanded}
            svgTruePath={SVG_EXPANDED_PATH}
            svgFalsePath={SVG_COLLAPSED_PATH}
        />
        <div class="title">{title}</div>
    </div>
</div>
